import React, { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCaretUp,
    faCaretDown
  } from "@fortawesome/free-solid-svg-icons";
import "./Accordion.css";

const Accordion = ({ title, content }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="accordion-item">
      <div className="accordion-title" onClick={() => setIsActive(!isActive)}>
        <div className='accordion-title-text'>{title}</div>
        <div className='accordion-title-control'><FontAwesomeIcon icon={isActive ? faCaretUp : faCaretDown}/></div>
      </div>
      <div className={"accordion-content" + (isActive ? " open" : " closed")}>{content}</div>
    </div>
  );
};

export default Accordion;